import { createI18n } from '@learnforge/i18n';
import { locales } from './locales';
import type { SetsKey } from './locales/keys';

export const i18n = createI18n<SetsKey>({
  gameId: 'sets',
  locales,
});

export type SetsI18n = typeof i18n;
